var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container cc-education"},[_c('div',{staticClass:"h4 text-center mb-4 title"},[_vm._v("Tanulmányok")]),_c('education-modul')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }